import { ReactNode, useMemo } from 'react';
import { ApolloProvider } from '@apollo/client/react';
import { createApolloClient } from '../clients/apolloClient';
import { useAuthContext } from './AuthContext';
import { Loading } from '../components/common/Loading';

export const ApolloClientProvider = ({ children }: { children: ReactNode }) => {
  const { tenantId, authToken } = useAuthContext();

  const apolloClient = useMemo(() => {
    if (!authToken || !tenantId) {
      return null;
    }

    return createApolloClient({ authToken, tenantId });
  }, [authToken, tenantId]);

  if (!apolloClient) {
    return <Loading />;
  }

  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
};
